import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useGetOrganizations } from '../../../../api/origanization/origanization';
import { useDefaultOptions } from '../../../../hooks/api';
import { OrganizationTree } from './OrganizationTree';

/**
 * タブタイトル
 * @returns
 */
function Title() {
  // 言語情報
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('CMS-POC|権限情報')}</title>
    </Helmet>
  );
}
function OrganizationTreePage() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const { isLoading, isError, data, refetch } = useGetOrganizations(options);

  if (isLoading) {
    return <>{t('お待ちください。')}</>;
  }

  if (isError || data.data.companies == null) {
    return <>{t('エラーが発生しました。')}</>;
  }
  return (
    <div id="main">
      <Title />
      <OrganizationTree companies={data?.data.companies || []} refetch={refetch} />
    </div>
  );
}
export default OrganizationTreePage;
